import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ReactLoading from "react-loading";
import Home from "./Pages/Home";
import Navbar from "./Components/home/Navbar";
import SearchedPr from "./Components/productsPage/SearchedPr";
import PrDeatail from "./Pages/Pr_deatail";
import Cart from "./Pages/Cart";
import Checkout from "./Pages/Checkout";
import Islogin from "./helper/Islogin";
import LoginModal from "./Components/LoginModal";
import SignUpModal from "./Components/SignupModal";
import Orders from "./Pages/Orders";
import AlertModel from "./Components/modals/AlertModal";
import OrderConfirm from "./Pages/OrderConfirm";
import AdminRoutes from "./admin/AdminRoutes";
import ProgressBarComp from "./helper/ProgressBar";
import { useAuthContext } from "./Context/LoginSignupContext";

function App() {
  Islogin();
  console.log("appp render*************");
  const { isLogin, loginLoading } = useAuthContext();
  const showNavbarAndModals =
    (window.location.pathname.startsWith("/admin") && !isLogin) ||
    !window.location.pathname.startsWith("/admin");

  return !loginLoading ? (
    <>
      <div className="App">
        {showNavbarAndModals && <Navbar />}
        {showNavbarAndModals && <LoginModal />}
        {showNavbarAndModals && <SignUpModal />}

        <Routes>
          <Route path="/*" element={<Home />} />
          <Route path="/search" element={<SearchedPr />} />
          <Route path="/details/:prId" element={<PrDeatail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orderConfirm" element={<OrderConfirm />} />
          <Route
            path="/admin/*"
            element={isLogin ? <AdminRoutes /> : <Home />}
          />
        </Routes>
        <AlertModel />
        <ProgressBarComp />
      </div>
    </>
  ) : (
    <div className="react-loading">
      <ReactLoading type={"spokes"} color={"Black"} height={20} width={100} />
    </div>
  );
}

export default App;
